import React from 'react';
import clsx from 'clsx';

import scss from './PreviewCard.module.scss';

export const PREVIEW_CARD_BACKDROPS = {
  SURFACE: 'surface',
  PHOTO: 'photo',
};

function PreviewCard({ name, backdrop = PREVIEW_CARD_BACKDROPS.SURFACE, isTarget, frameClassName, onClick, children }) {
  return (
    <button type='button' className={clsx(scss.card, isTarget && scss.cardTarget)} title={name} onClick={onClick}>
      <span
        className={clsx(scss.frame, backdrop === PREVIEW_CARD_BACKDROPS.PHOTO ? scss.framePhoto : scss.frameSurface, frameClassName)}>
        {children}
      </span>
      <span className={scss.name}>{name}</span>
    </button>
  );
}

export default PreviewCard;
